// src/components/Card.js

import React from 'react';
import './Card.css';

const Card = ({ children, image, className, onClick }) => {
  return (
    <div className={`card ${className}`} onClick={onClick}>
      {image && <img src={image} alt={""} className="card-image" />}
      <div className="card-content">{children}</div>
    </div>
  );
};

export default Card;